import { render, staticRenderFns } from "./AssignmentSharingTable.vue?vue&type=template&id=fcb77794&scoped=true&"
import script from "./AssignmentSharingTable.vue?vue&type=script&lang=js&"
export * from "./AssignmentSharingTable.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentSharingTable.vue?vue&type=style&index=0&id=fcb77794&scoped=true&lang=css&"
import style1 from "./AssignmentSharingTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb77794",
  null
  
)

export default component.exports